

import React, { useEffect, useState } from 'react';
import call from '../../service';
import toastDisplay from '../../utils/toastNotification';

const QuotRaiseModal = ({ userTokenDetails, setshowQuotRaiseModal, showQuotRaiseModal, setrefresh, refresh }) => {
  //---------------------------------------------------------------------------------------------------------------------
  //States
  const [shippers, setShippers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [data, setData] = useState({ quoatUsers: [] });
  const [showLoader, setshowLoader] = useState(false);
  const contractData = showQuotRaiseModal.contractData
  //---------------------------------------------------------------------------------------------------------------------
  // use effects
  useEffect(() => {

    //------------------------------------------------------------------
    //API Calls
    setshowLoader(true)
    call('POST', 'getUsersListing', { "searchUserType": 5, "searchKey": '', "network": "fullnetwork", "userAvatars": false }).then((result) => {
      console.log("result of api in getUsersListing-->", result)
      setshowLoader(false)
      setShippers(result)
    }).catch((e) => {
      setshowLoader(false)
      console.log('error in getUsersListing', e);
    })

    call('POST', 'getUsersListing', { "searchUserType": 10, "searchKey": '', "network": "fullnetwork", "userAvatars": false }).then((result) => {
      // console.log("result of api in getUsersListing-->", result)
      setshowLoader(false)
      setBrokers(result)
    }).catch((e) => {
      setshowLoader(false)
      console.log('error in getUsersListing', e);
    })

    //------------------------------------------------------------------

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //---------------------------------------------------------------------------------------------------------------------

  //---------------------------------------------------------------------------------------------------------------------
  // Handlers
  const handleChange = (event) => {
    event.persist();
    setData(data => ({ ...data, [event.target.name]: event.target.value }));
  }

  const handleCheckbox = (event) => {
    event.persist();
    let tempArray = data[event.target.name] ? [...data[event.target.name]] : []
    let selectedUser = event.target.value / 1
    let index = tempArray.indexOf(selectedUser)
    if (index !== -1) {
      tempArray = tempArray.slice(0, index)
    } else {
      tempArray.push(selectedUser / 1)
    }
    setData(data => ({ ...data, [event.target.name]: tempArray }));
  }

  const handleCheckAllShipper = (event) => {
    event.persist();
    let tempArray = [...data.quoatUsers]
    for (let i = 0; i < shippers.length; i++) {
      if (!tempArray.includes(shippers[i])) {
        tempArray.push(shippers[i].id)
      }
    }
    setData(data => ({ ...data, quoatUsers: tempArray }));
  }

  const handleCheckAllBroker = (event) => {
    event.persist();
    let tempArray = [...data.quoatUsers]
    for (let i = 0; i < brokers.length; i++) {
      if (!tempArray.includes(brokers[i])) {
        tempArray.push(brokers[i].id)
      }
    }
    setData(data => ({ ...data, quoatUsers: tempArray }));
  }

  //---------------------------------------------------------------------------------------------------------------------

  console.log("data in request =>", data)
  //---------------------------------------------------------------------------------------------------------------------
  // Submit handler
  function handleSubmitQuoat() {

    let formData = new FormData();

    formData.append("sendToUsers", data.quoatUsers);
    formData.append("quotLoadingRate", data.quotLoadingRate);
    formData.append("quotUnloadingRate", data.quotUnloadingRate);
    formData.append("contractId", showQuotRaiseModal.contract_id);
    formData.append("contractNo", showQuotRaiseModal.contract_no);

    setshowLoader(true)
    call('POST', 'raiseQuotation', formData).then((result) => {
      setrefresh(refresh + 1)
      setshowLoader(false)
      setshowQuotRaiseModal({ modal: false })
    }).catch((e) => {
      setshowLoader(false)
      console.log("Error while raising quotation request:", e);
      toastDisplay(e, "error")
    })

  }
  //---------------------------------------------------------------------------------------------------------------------


  return (
    <>
      {showQuotRaiseModal.modal && <div className={"modal" + (showQuotRaiseModal.modal ? " show" : "")} id="DocumentUpload">
        <div className="modal-dialog modal-xl border-inner" id="parent_class">
          <div className="modal-content">
            <div className="modal-header primary">
              <h4 className="modal-title text-white">Send Shipment Quotation</h4>
              <button type="button" className="close" onClick={() => { setshowQuotRaiseModal(false) }}>×</button>
            </div>
            <div className="modal-body calc-inner-modal">
              {showLoader === true && (<div className="loading-overlay"><span><img className="" src="assets/images/loader.gif" alt="description" /></span></div>)}

              <div className=" col-md-12 row" >

                <div className="col-md-12">
                  <ul className="price-ul">
                    <li>
                      <div className="price-left">{contractData.contract_name}</div>
                      <div className="price-right">Contract </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.buyername}</div>
                      <div className="price-right">Importer </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.suppliername}</div>
                      <div className="price-right">Exporter </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.commodity_name}</div>
                      <div className="price-right">Commodity </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.quantity}</div>
                      <div className="price-right">Quantity </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.laycan_start}</div>
                      <div className="price-right">Laycan Start </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.laycan_end}</div>
                      <div className="price-right">Laycan End </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.created_at}</div>
                      <div className="price-right">Created at </div>
                    </li>
                  </ul>
                </div>

                <div className=" col-md-12 row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Loading Rate (PDPR)</label>
                      <input type="text" name="quotLoadingRate" placeholder="" value={data.quotLoadingRate} className="form-control" onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Unloading Rate (PDPR)</label>
                      <input type="text" name="quotUnloadingRate" placeholder="" value={data.quotUnloadingRate} className="form-control" onChange={handleChange} />
                    </div>
                  </div>
                </div>

                <div className=" col-md-12 row mt-2">
                  <div className=" col-md-6">
                    <label >Select Ship Owners to send</label>
                    {(shippers.length > 1) &&
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="checkAll" name="shipperCheckall" id="shipperCheckall" onChange={handleCheckAllShipper} />
                        <label className="form-check-label" htmlFor="shipperCheckall">"Check All"</label>
                      </div>
                    }
                    {shippers && shippers.length ? shippers.map((user, index) => {
                      return (
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value={user.id} name="quoatUsers" id={"quoatUsersS" + index} onChange={handleCheckbox} checked={data.quoatUsers.includes(user.id)} />
                          <label className="form-check-label" htmlFor={"quoatUsersS" + index}>{user.company_name}</label>
                        </div>
                      )
                    }) : ""
                    }
                  </div>
                  <div className=" col-md-6">
                    <label >Select Brokers to send</label>
                    {(brokers.length > 1) &&
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="checkAll" name="brokerCheckall" id="brokerCheckall" onChange={handleCheckAllBroker} />
                        <label className="form-check-label" htmlFor="brokerCheckall">"Check All"</label>
                      </div>
                    }
                    {brokers && brokers.length ? brokers.map((user, index) => {
                      return (
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value={user.id} name="quoatUsers" id={"quoatUsersB" + index} onChange={handleCheckbox} checked={data.quoatUsers.includes(user.id)} />
                          <label className="form-check-label" htmlFor={"quoatUsersB" + index}>{user.company_name}</label>
                        </div>
                      )
                    }) : ""
                    }
                  </div>

                </div>
              </div>
            </div>
            <div className="modal-footer primary">
              <button type="button" className="btn btn-primary btn-sm float-right" onClick={() => handleSubmitQuoat()} >Submit</button>
            </div>
          </div>
        </div>
      </div >}
    </>)
}


export default QuotRaiseModal
